import { useState } from 'react';

import { PriceDisplay } from '../../components/PriceDisplay';
import { ChevronDownIcon } from '../../icons/ChevronDownIcon';
import { Content, Trigger, TriggerLeft, Wrapper } from './CheckoutSummaryMobile.styles';
import type {
  CheckoutSummaryMobileLabels,
  CheckoutSummaryMobileProps,
} from './CheckoutSummaryMobile.types';

const DEFAULT_LABELS: Required<CheckoutSummaryMobileLabels> = {
  showSummary: 'Show summary',
  hideSummary: 'Hide summary',
};

export function CheckoutSummaryMobile({
  total,
  children,
  defaultOpen = false,
  locale,
  labels,
}: CheckoutSummaryMobileProps) {
  const merged = { ...DEFAULT_LABELS, ...labels };
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Wrapper data-testid="checkout-summary-mobile">
      <Trigger
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls="checkout-summary-mobile-content"
      >
        <TriggerLeft data-open={open}>
          {open ? merged.hideSummary : merged.showSummary}
          <ChevronDownIcon />
        </TriggerLeft>
        {total && (
          <PriceDisplay
            amount={total.amount}
            currencyCode={total.currencyCode}
            locale={locale}
            size="medium"
            weight="medium"
          />
        )}
      </Trigger>
      {open && <Content id="checkout-summary-mobile-content">{children}</Content>}
    </Wrapper>
  );
}
